import { render, staticRenderFns } from "./productUnsalable.vue?vue&type=template&id=151604ee&scoped=true&"
import script from "./productUnsalable.vue?vue&type=script&lang=js&"
export * from "./productUnsalable.vue?vue&type=script&lang=js&"
import style0 from "./productUnsalable.vue?vue&type=style&index=0&id=151604ee&prod&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "151604ee",
  null
  
)

export default component.exports